export default __webpack_public_path__ + "static/media/navigation_arrow_black.1bea9699.svg";